import { Metadata } from '../types';

export function combineMetadata(...args: Metadata[]): Metadata {
  let result = args[0];

  for (let i = 1; i < args.length; i++) {
    if (args[i] != null) result = { ...result, ...args[i] };
  }

  return result ?? null;
}
